import { get } from '../api';

export default async () => {
  return await get('/public_landing_pages');
};
